module.exports = __webpack_public_path__ + "static/img/icon.ca18e15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_11/icon.jpg
// module id = lYOW
// module chunks = 0